<div class="new-manager">
  <div class="main-new-manager">
    <div class="dialog-title-row">
      <h1 class="title-new-manager m-0">Editar sesión</h1>
      <button class="btn-close-dialog" mat-dialog-close><i class="fa-light fa-times"></i></button>
    </div>

    <!-- Nombre del evento -->
    <div class="event-info">
      <p class="event-label">Evento:</p>
      <p class="event-name">{{ eventName }}</p>
    </div>

    <form [formGroup]="sessionForm">

      <!-- Selector de fecha y hora -->
      <div class="session-row">
        <div class="form-field datetime-field">
          <app-datetime-selector
            [date]="sessionForm.get('date').value"
            [time]="sessionForm.get('time').value"
            [dateEventSaved]="sessionForm.get('dateString').value"
            (saveDate)="saveDate($event)">
          </app-datetime-selector>
        </div>

        <!-- Checkbox Todo el día -->
        <div class="form-field checkbox-field">
          <mat-checkbox
            formControlName="allDay"
            color="primary"
            (change)="toggleAllDay()">
            Todo el día
          </mat-checkbox>
        </div>

        <!-- Botón eliminar sesión -->
        <button
          type="button"
          class="btn-remove"
          (click)="deleteSession()">
          <i class="fa-regular fa-trash"></i>
        </button>
      </div>

    </form>

    <!-- Activar / desactivar sesión -->
    <div class="toggle-active-section" *ngIf="!isTemporarySession">
      <mat-divider></mat-divider>
      <div class="toggle-active-row">
        <div class="toggle-active-info">
          <p class="toggle-active-label">Visibilidad de la sesión</p>
          <p class="toggle-active-hint">
            <span *ngIf="sessionActive" class="status-active">
              <i class="fa-solid fa-circle-check"></i> Activa — visible y disponible para la venta
            </span>
            <span *ngIf="!sessionActive" class="status-inactive">
              <i class="fa-solid fa-circle-xmark"></i> Inactiva — oculta del público
            </span>
          </p>
        </div>
        <mat-slide-toggle
          class="toggle-pink"
          [(ngModel)]="sessionActive"
          [ngModelOptions]="{standalone: true}"
          color="primary"
          (change)="toggleActive()">
        </mat-slide-toggle>
      </div>
    </div>

  </div>

  <mat-divider></mat-divider>

  <!-- Footer con botones -->
  <div class="footer-new-manager">
    <div class="btn-new btn-create m-0" (click)="saveSession()" [class.disabled]="sessionForm.invalid || isSaving">
      <p class="m-0">Guardar</p>
    </div>
  </div>
</div>
